import { useLang } from "../lib/i18n";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-archivo text-2xl font-black uppercase tracking-tight text-[#f3ecdc] md:text-3xl">
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-amber/80" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
    <div className="overflow-hidden border-y border-[#181510] bg-[#181510] py-8" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        <Row items={t.marquee} />
        <Row items={t.marquee} />
      </div>
    </div>
  );
};
